import { ADD_ERROR, REMOVE_ERROR } from '../actions/ErrorActions';

export function ErrorsReducer(state = [], action) {
  switch (action.type) {

    case ADD_ERROR:
      return state.concat([action.message]);

    case REMOVE_ERROR:
      return state.filter((error, i) => i !== action.index);

    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/reducers/ErrorsReducer.js